import { useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import HistoryIcon from "@mui/icons-material/History";

import IconButton from "features/components/IconButton";
import Menu from "features/components/Menu";

import { useThreadList } from "./hooks";
import ThreadListPanel from "./ThreadListPanel";

const ThreadList = () => {
  const { t } = useTranslation("duck");
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const inputRef = useRef<HTMLInputElement | null>(null);

  const { isDisabled } = useThreadList();

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    if (!isDisabled) {
      setAnchorEl(event.currentTarget);
    }
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <IconButton
        onClick={handleClick}
        disabled={isDisabled}
        color="secondary"
        data-testid="open-thread-list-button-duck"
        size="small"
        tooltip={t("chat_history")}
      >
        <HistoryIcon />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        disableScrollLock={true}
        style={{ maxWidth: "50ex" }}
        autoFocus={false}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
        sx={{
          "& .MuiList-padding": {
            padding: 0,
            paddingBottom: "0.5rem",
          },
        }}
      >
        <ThreadListPanel onClose={handleClose} inputRef={inputRef} />
      </Menu>
    </>
  );
};

export default ThreadList;
